import { createActions } from 'redux-actions';

export const {
  //GET FILTER OFFERS
  getFilterOffers,
  getFilterOffersSuccess,
  getFilterOffersError,
  getAllOffers,
  getOffersSuccess,
  getOffersError,
  // getAllOffersById,
  // FILTER REQUESTS
  filterRequests,
  filterRequestsSuccess,
  filterRequestsError,
  getOffer,
  getOfferSuccess,
  getOfferFailure,
  createOffer,
  createOfferSuccess,
  createOfferFailure,
  //SEARCH REQUEST
  searchOffers,
  searchOffersSuccess,
  searchOffersError,
  currentRequest,
  currentRequestSuccess,
  currentRequestFailure,
  // update Offer
  updateOffer,
  updateOfferSuccess,
  updateOfferError,
} = createActions(
  'GET_FILTER_OFFERS',
  'GET_FILTER_OFFERS_SUCCESS',
  'GET_FILTER_OFFERS_ERROR',
  'GET_ALL_OFFERS',
  'GET_OFFERS_SUCCESS',
  'GET_OFFERS_ERROR',
  // 'GET_ALL_OFFERS_BY_ID',
  'FILTER_REQUESTS',
  'FILTER_REQUESTS_SUCCESS',
  'FILTER_REQUESTS_ERROR',
  'GET_OFFER',
  'GET_OFFER_SUCCESS',
  'GET_OFFER_FAILURE',
  'CREATE_OFFER',
  'CREATE_OFFER_SUCCESS',
  'CREATE_OFFER_FAILURE',
  'SEARCH_OFFERS',
  'SEARCH_OFFERS_SUCCESS',
  'SEARCH_OFFERS_ERROR',
  'CURRENT_REQUEST',
  'CURRENT_REQUEST_SUCCESS',
  'CURRENT_REQUEST_FAILURE',
  'UPDATE_OFFER',
  'UPDATE_OFFER_SUCCESS',
  'UPDATE_OFFER_ERROR'
);
